import { API } from "@/lib/api";
import { logger } from "@/lib/logger";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function ensureSwRegistered() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/sw.js");
    return reg;
  } catch (e) {
    return null;
  }
}

export async function subscribePush() {
  if (!isPushSupported()) throw new Error("Push non supporte sur ce navigateur");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission refusee");

  const reg = (await navigator.serviceWorker.getRegistration()) || (await ensureSwRegistered());
  if (!reg) throw new Error("Service Worker indisponible");

  const r = await fetch(`${API}/push/public-key`);
  const { public_key: pub } = await r.json();
  if (!pub) throw new Error("Cle VAPID indisponible");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(pub),
    });
  }
  // Send subscription to server
  await fetch(`${API}/push/subscribe`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ endpoint: sub.endpoint, keys: sub.toJSON().keys }),
  });
  return sub;
}

export async function unsubscribePush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) {
    try {
      await fetch(`${API}/push/unsubscribe`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ endpoint: sub.endpoint, keys: sub.toJSON().keys }),
      });
    } catch (e) {
      logger.warn("Push unsubscribe API failed:", e?.message || e);
    }
    await sub.unsubscribe();
  }
}

export async function getPushStatus() {
  if (!isPushSupported()) return { supported: false, subscribed: false, permission: "default" };
  const permission = Notification.permission;
  let subscribed = false;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg && (await reg.pushManager.getSubscription());
    subscribed = !!sub;
  } catch (e) {
    logger.warn("Failed to read push subscription:", e?.message || e);
  }
  return { supported: true, subscribed, permission };
}
